const DATASCIENT_TOKEN = 'datascient_token';

export const setToken = (token) => {
  localStorage.setItem(DATASCIENT_TOKEN, token);
};

export const getToken = (token) => {
  localStorage.getItem(DATASCIENT_TOKEN);
};

export function getHeadersWithToken() {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}
